import Cookies from 'js-cookie'

// Cookie 由前端写入时无法设置 HttpOnly；这里至少统一补充 SameSite，并仅在 HTTPS
// 环境增加 Secure，避免本地 HTTP 开发环境无法写入 Cookie。
const getCookieAttributes = () => {
  const attributes = { sameSite: 'Lax' }
  if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
    attributes.secure = true
  }
  return attributes
}

// set cookie
export default {
  setCookie (key, value) {
    return Cookies.set(key, value, getCookieAttributes())
  },
  getCookie (key) {
    return Cookies.get(key)
  },
  removeCookie (key) {
    Cookies.remove(key)
  },
  /**
   * 清理工作人员端全部认证 Cookie。
   *
   * 历史代码登录写入 perms，退出却只删除 role，导致换账号时可能残留旧权限。
   * role 已不是当前守卫使用字段，但仍一并删除以兼容旧版本遗留 Cookie。
   */
  clearAuthCookies () {
    Cookies.remove('token')
    Cookies.remove('perms')
    Cookies.remove('role')
  }
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js